import React from 'react';
import './MenuNodes.scss';
import Nodes from './Nodes/Nodes';
import myModulesImage from "../../../styles/svg_icons/menuside_icons/mymodules.svg";
import modulesImage from "../../../styles/svg_icons/menuside_icons/modules.svg";
export default class MenuNodes extends React.Component {

 
    //RENDER MENU NODES
renderNodes() {
    const { dispatch } = this.props;
   

    const nameCategory = ( this.props.menuSide.selectedModule === '13') ? this.props.menuSide.dataMenuNodesPrivate : this.props.menuSide.dataMenuNodes;
    //console.log(nameCategory);
;
    const viewComponent = (nameCategory === false) ? false : this.props.menuSide.categoryView;

    const titleMyModules = 
    <div className='title'>
        <img src={myModulesImage} className ="title-img" alt="title"/>
        <p>Мои модули</p>
    </div>
        
    const titleModules = 
        <div className='title'>
            <img src={modulesImage} className ="title-img" alt="title"/>
            <p>Модули</p>
        </div>
    // check if public/private module
    const statusNote = true ? this.props.menuSide.selectedModule === '2' : false;    

    if (viewComponent) {
        return (
           <div className="MenuNodes">
            {this.props.menuSide.selectedModule === '13' && titleMyModules}
            {this.props.menuSide.selectedModule === '2' && titleModules}
            {nameCategory.map((element, index) => 
                <Nodes  
                    key={index}
                    element={element}
                    userId={this.props.userId}
                    favoritesQuizes={this.props.favoritesQuizes}
                    quizViewChangeRedux={this.props.quizViewChangeRedux}
                    statusNote={statusNote}
                    dispatch={dispatch}
                    authData={this.props.authData}
                  />
             
                  )}
            </div>  
        )
        
    } 




    }
    render() {
        return (
            <div className="MenuNodes">
                {this.renderNodes()}
            </div>
        )
    }
}